import { Component, Input } from '@angular/core';
import { MaterialCheckModel } from '@evorait/pace-core';
import { faChevronDown, faChevronUp, faBoxes } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-material-availability-details',
    templateUrl: './material-availability-details.component.html',
    styleUrls: ['./material-availability-details.component.scss'],
    standalone: false,
})
export class MaterialAvailabilityDetailsComponent {
    @Input() public material: MaterialCheckModel;
    @Input() public responsePartSet: MaterialCheckModel[] = [];

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    protected faBoxes = faBoxes;
    public isCollapsed = true;
}
